/**
 * Butir dashboard per peran — yang menuntut TINDAKAN, di paling atas.
 *
 * ⛔ NOL ADA TOMBOL TUTUP, DAN ITU INTI RANCANGANNYA.
 *
 * Owner 31 Agustus 2026: *"untuk yg perlu tindakan maka notif tidak hilang
 * sebelum solved atau selesai dikerjakan."*
 *
 * Butirnya DITURUNKAN dari keadaan nyata tiap kali dibaca, bukan disimpan
 * sebagai notifikasi. "3 PR menunggu persetujuan" hilang HANYA saat ketiganya
 * benar-benar diputuskan. Notifikasi yang bisa ditutup akan ditutup untuk
 * merapikan layar — lalu pekerjaannya hilang dari pandangan tanpa selesai.
 *
 * ---------------------------------------------------------------------------
 * ⛔ YANG NOL DAN YANG GAGAL DIHITUNG ADALAH DUA HAL BERBEDA
 * ---------------------------------------------------------------------------
 *
 *   jumlah  0   benar-benar nol ada pekerjaan  -> redup, tetap tampil
 *   jumlah -1   GAGAL dihitung                 -> ditandai, karena "0" palsu
 *               di layar ini berarti orang mengira pekerjaannya nol ada
 *   jumlah -2   butir yang perlu dibuka        -> nol punya angka, punya tautan
 *
 * ⚠ Baris `-1` yang paling penting. Kegagalan satu tabel yang ditampilkan
 *   sebagai "0" adalah kebohongan yang bentuknya menenangkan.
 */
import React from "react";
import { Link } from "react-router-dom";

const NADA = {
  perlu: {
    kotak: "border-danger-soft-border bg-danger-soft",
    angka: "text-danger-soft-foreground",
  },
  awas: {
    kotak: "border-warning-soft-border bg-warning-soft",
    angka: "text-warning-soft-foreground",
  },
  kabar: {
    kotak: "border-border bg-card",
    angka: "text-foreground",
  },
};

function Kartu({ b }) {
  // ⛔ Butir `perlu` yang jumlahnya NOL diturunkan jadi `kabar` — supaya
  //    merahnya berarti sesuatu. Layar yang selalu merah berhenti dibaca
  //    sebagai peringatan dalam seminggu.
  const nada = (b.jumlah === 0 && b.nada === "perlu") ? "kabar" : b.nada;
  const n = NADA[nada] || NADA.kabar;
  const gagal = b.jumlah === -1;
  const buka = b.jumlah === -2;

  const isi = (
    <div className={`h-full rounded-xl border p-4 ${gagal ? "border-destructive/50 bg-destructive/10" : n.kotak}`}>
      <p className="text-sm text-muted-foreground">{b.judul}</p>
      {gagal ? (
        /* ⚠ Kegagalan DITAMPILKAN, nol disamarkan jadi nol. */
        <p className="mt-1 text-sm font-semibold text-destructive">
          Tidak bisa dihitung — angka ini tidak bisa dipercaya
        </p>
      ) : buka ? (
        <p className="mt-1 text-lg font-semibold text-foreground">Buka →</p>
      ) : (
        <p className={`mt-1 text-3xl font-bold tabular-nums ${n.angka}`}>
          {b.jumlah}
        </p>
      )}
      {b.rinci && (
        <p className="mt-1 text-xs text-muted-foreground">{b.rinci}</p>
      )}
    </div>
  );

  return b.tautan ? (
    <Link to={b.tautan} className="block transition hover:opacity-90">{isi}</Link>
  ) : isi;
}

export default function ButirDashboard({ data }) {
  if (!data) return null;
  if (data.sebab_kosong) {
    return (
      <div className="rounded-xl border border-border bg-card p-4 text-sm text-muted-foreground">
        {data.sebab_kosong}
      </div>
    );
  }
  if (!data.butir?.length) return null;

  // Yang menuntut tindakan di DEPAN — aturan 2 draft dashboard.
  const urut = [...data.butir].sort((a, b) => {
    const skor = (x) => (x.jumlah > 0 && x.nada === "perlu" ? 0
      : x.jumlah > 0 && x.nada === "awas" ? 1
      : x.jumlah === -1 ? 2 : x.jumlah === -2 ? 3 : 4);
    return skor(a) - skor(b);
  });

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {urut.map((b, i) => <Kartu key={i} b={b} />)}
    </div>
  );
}
